import { useEffect, useRef, useState } from "react";

// Difiere el montaje de una sección hasta que está cerca del viewport.
// Reserva espacio con minHeight para no provocar saltos de layout (CLS).
export function InViewSection({ children, minHeight = 400, rootMargin = "600px", testid }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (show) return;
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") { setShow(true); return; }
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { setShow(true); io.disconnect(); }
    }, { rootMargin });
    io.observe(el);
    return () => io.disconnect();
  }, [show, rootMargin]);

  return (
    <div ref={ref} data-testid={testid} style={show ? undefined : { minHeight }}>
      {show ? children : null}
    </div>
  );
}
